import { useLocation } from 'react-router';
import type { Page } from './page-url-path';
import { getPageByPath } from './get-page-by-path';

export const useGetCurrentPage = (): Page | undefined => {
  const { pathname } = useLocation();
  return getPageByPath(pathname);
};
